import { render, staticRenderFns } from "./InputRegion.vue?vue&type=template&id=3a9cee98&scoped=true&"
import script from "./InputRegion.vue?vue&type=script&lang=ts&"
export * from "./InputRegion.vue?vue&type=script&lang=ts&"
import style0 from "./InputRegion.vue?vue&type=style&index=0&id=3a9cee98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9cee98",
  null
  
)

export default component.exports